
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1 33.593C1 37.683 4.256 41 8.273 41c2.76 0 5.132-1.584 6.363-3.89C15.868 39.415 18.24 41 21 41s5.132-1.584 6.364-3.89c1.231 2.306 3.603 3.89 6.363 3.89C37.744 41 41 37.683 41 33.593M17.364 10.259V1h7.272v9.259M8.273 24.867v-11.83c0-1.535 1.22-2.778 2.727-2.778h20c1.506 0 2.727 1.243 2.727 2.777v11.831"}}),_c('path',{attrs:{"d":"M8.273 34.332l-3.637-7.407L21 17.665l16.364 9.26-3.637 7.407M21 17.666v12.962"}})])])
          )
        }
      }
    